import React from 'react'

const IconChair = ({
  className = '',
  strokeWidth = '1'
}: {
  className?: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
    >
      <path
        d="M12 8.5C12.2761 8.5 12.5 8.27614 12.5 8V7C12.5 6.73478 12.6054 6.48043 12.7929 6.29289C12.9804 6.10536 13.2348 6 13.5 6C13.7652 6 14.0196 6.10536 14.2071 6.29289C14.3946 6.48043 14.5 6.73478 14.5 7V12.5H0.5V7C0.5 6.73478 0.605357 6.48043 0.792893 6.29289C0.980429 6.10536 1.23478 6 1.5 6C1.76522 6 2.01957 6.10536 2.20711 6.29289C2.39464 6.48043 2.5 6.73478 2.5 7V8C2.5 8.27614 2.72386 8.5 3 8.5H12Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 4V2.5C2.5 1.39543 3.39543 0.5 4.5 0.5H10.5C11.6046 0.5 12.5 1.39543 12.5 2.5V4"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <rect
        x="2"
        y="12"
        width={strokeWidth}
        height="3"
        rx="0.5"
        fill="currentColor"
      />
      <rect
        x="12"
        y="12"
        width={strokeWidth}
        height="3"
        rx="0.5"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconChair
